import { useState, FormEvent } from 'react';

export default function ConsultationSection() {
  const [submitting, setSubmitting] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);

    const formData = new FormData(e.currentTarget);
    const data = new URLSearchParams();
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d5ht7t3ihlvellpk563g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString(),
      });

      if (response.ok) {
        alert('Đăng ký tư vấn thành công! Chúng tôi sẽ liên hệ với bạn sớm.');
        e.currentTarget.reset();
        setCharCount(0);
      } else {
        alert('Có lỗi xảy ra. Vui lòng thử lại!');
      }
    } catch (error) {
      alert('Có lỗi xảy ra. Vui lòng thử lại!');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="registration" className="py-20 bg-gradient-to-b from-white to-orange-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Đăng ký <span className="text-orange-600">Tư vấn</span></h2>
          <p className="text-lg text-gray-600">Điền thông tin để nhận tư vấn chi tiết về chương trình đào tạo, báo giá kit hoặc hợp tác nhượng quyền</p>
        </div>

        <div className="bg-white rounded-xl shadow-xl p-8 border border-gray-100">
          <form id="esapcor-registration-form" data-readdy-form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div className="md:col-span-2">
                <label className="block text-sm font-semibold text-gray-900 mb-2">Nhu cầu <span className="text-red-500">*</span></label>
                <select 
                  name="need" 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm cursor-pointer" 
                  required
                >
                  <option value="">-- Chọn nhu cầu --</option>
                  <option value="Học">Đăng ký học</option>
                  <option value="Mua Kit">Mua Robotics Kit</option>
                  <option value="Nhượng quyền">Nhượng quyền / Hợp tác</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">Họ và tên <span className="text-red-500">*</span></label>
                <input 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm" 
                  placeholder="Nguyễn Văn A" 
                  required 
                  name="fullName"
                  type="text"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">Số điện thoại <span className="text-red-500">*</span></label>
                <input 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm" 
                  placeholder="0912345678" 
                  required 
                  type="tel" 
                  name="phone"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">Email <span className="text-red-500">*</span></label>
                <input 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm" 
                  placeholder="email@example.com" 
                  required 
                  type="email" 
                  name="email"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">Đơn vị / Trường</label>
                <input 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm" 
                  placeholder="THPT Lê Quý Đôn" 
                  name="organization"
                  type="text"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-semibold text-gray-900 mb-2">Tỉnh / Thành phố</label>
                <input 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm" 
                  placeholder="Hà Nội" 
                  name="province"
                  type="text"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-semibold text-gray-900 mb-2">Ghi chú</label>
                <textarea 
                  name="note" 
                  rows={4} 
                  maxLength={500} 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm resize-none" 
                  placeholder="Thông tin thêm về nhu cầu của bạn..."
                  onChange={(e) => setCharCount(e.target.value.length)}
                ></textarea>
                <div className="text-right text-xs text-gray-500 mt-1">{charCount}/500 ký tự</div>
              </div>
            </div>

            <button 
              className="whitespace-nowrap w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-4 rounded-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
              type="submit"
              disabled={submitting}
            >
              {submitting ? (
                <>
                  <i className="ri-loader-4-line animate-spin mr-2"></i>
                  Đang gửi...
                </>
              ) : (
                <>
                  <i className="ri-send-plane-fill mr-2"></i>
                  Gửi đăng ký
                </>
              )}
            </button>
          </form>
        </div>

        <div className="mt-8 text-center">
          <p className="text-gray-600 mb-4">Hoặc liên hệ trực tiếp:</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="tel:0902768879" className="flex items-center text-orange-600 font-semibold hover:text-orange-700 cursor-pointer">
              <i className="ri-phone-fill mr-2"></i>0902 768 879
            </a>
            <span className="hidden sm:inline text-gray-400">|</span>
            <a href="tel:0977276143" className="flex items-center text-orange-600 font-semibold hover:text-orange-700 cursor-pointer">
              <i className="ri-phone-fill mr-2"></i>0977 276 143
            </a>
            <span className="hidden sm:inline text-gray-400">|</span>
            <a href="mailto:info@esapcor.vn" className="flex items-center text-orange-600 font-semibold hover:text-orange-700 cursor-pointer">
              <i className="ri-mail-fill mr-2"></i>info@esapcor.vn
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
